<app-block-products-carousel *ngIf="recentProducts.products?.length > 0"
    [header]="'recently-viewed-you-may-like' | t:'Recently Viewed, And You May Like!'"
    layout="grid-5" 
    [rows]="1"
    [loading]="recentProducts.loading"
    [products]="recentProducts.products"
    [groups]="recentProducts.groups"
    (groupChange)="groupChange(recentProducts, $event)"
></app-block-products-carousel> 